import { ApiGetRequest } from '../api-get-request';
import { ApiParameters } from '../api-parameters';

export class PaymentMethodGetRequest extends ApiGetRequest
{
    public constructor(playerId: number, webapiBasepath: string)
    {
        const parameters = new ApiParameters().addQueryParameter('playerId', playerId)
        super(
            'billwerk/getpaymentmethods',
            parameters,
            null,
            webapiBasepath
        );
    }
}
